import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import {LazyLoadEvent, MenuItem, SortEvent } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { GlobalMessage } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
import { EsignhomeService } from './esignhome.service';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { EsignhomemodalComponent } from '../../directives/esignhomemodal/esignhomemodal.component';
import { BehaviorSubject, Observable } from "rxjs"; 
@Component({
  selector: 'app-esignhome',
  templateUrl: './esignhome.component.html',
  styleUrls: ['./esignhome.component.css']
})
export class EsignhomeComponent {

  items: MenuItem[] = [];
  showcount: number = 0;
  hidecount: number = 0;
  tableData: any[] = [];
  selectedItem: MenuItem | null = null;
  commonScrollHeight = '';
  isActivefilter = false
  searchText: string;
  ref: DynamicDialogRef | undefined;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  options = [];
  paginatorArray = []
  visible: boolean = false;
  excel_paragraph = '';
  templatedownloadtext = '';
  exceldownloadModal = false;
  downloadformate = false;
  position = 'top';
  cols = [];
  message: GlobalMessage = new GlobalMessage()
  _selectedColumns = [];
  organisationList = [];
  userdata: any; 
  loggedInOrgId = "";
  selectedOrgId = "";

  constructor(public router: Router, public dialogService: DialogService,
    private esignservice: EsignhomeService, 
    public helpservice: PagehelpmodalService,
    private spinner: NgxSpinnerService,
    public utilityservice: Utilityservice) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text;
    this.userdata = this.utilityservice.getLoggeduser();
    this.loggedInOrgId = this.userdata?.orgid;
    this.selectedOrgId = this.loggedInOrgId;

    if (this.loggedInOrgId == "0") {
        this.getOrganisation();
    }
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight()
    //this.items = this.dashbordservice.getSdlcMenuList();
    this.callData();
    //    this.dynamiccols();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }

  onMenuItemClick(event: any): void {
    this.selectedItem = event.item;
    if (this.selectedItem.command) {
      this.selectedItem.command();
    }
  }
  /*
  dynamiccols(){
    
    this.cols=[
      {field:'sno',header:'Sno',type:'text',sort: true , filter:true, width:'2px !important',isChecked:true, class:'headerid'},
      {field:'closedflag',header:'Status',type:'text',sort: true , filter:true, width:'2px !important',isChecked:true, class:'headerid'},
      { field: "uuid", header: "UUID",type:'text',sort: true , filter:true, width:'30px', isChecked:true,class:'otherheader' } ,
      { field: "numberofsigns", header: "# of Signs",type:'text',sort: true ,filter:true, width:'10px',isChecked:true,class:'otherheader' }, 
      { field: "ctr", header: "Signed",type:'text',sort: true ,filter:true, width:'10px',isChecked:true,class:'otherheader' } ,
      { field: "rid", header: "ID",type:'text',sort: true ,filter:true, width:'10px',isChecked:true,class:'otherheader' } ,
      { field: "productname", header: "Module",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
      { field: "documenttype", header: "Doc Type",type:'text',sort: false , filter:false, width:'20px',isChecked:true,class:'otherheader' }, 
      { field: "pdffilename", header: "Doc Name",type:'text',sort: false , filter:false, width:'30px',isChecked:true,class:'otherheader' },
      { field: "createdon", header: "CreatedOn",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
      { field: "nam", header: "CreatedBy",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } 
    ]
   this._selectedColumns = this.cols;
  }
    
  */

  // getesigndata() {
  //   const payload: any = {}; 
  //   payload.orgId = this.selectedOrgId;
    
  //   this.spinner.show();
  //   this.esignservice.getESignData(payload).subscribe((data) => {
  //     this.tableData = data;
  //     this.options = this.utilityservice.getOptionDropdown(this.tableData.length);
  //     this.paginatorArray = this.options.map(e => e.value)
  //   }
  //   );
  //   this.spinner.hide();
  // } 

  idArray: number[] = [];
  

  getesigndata(filterdata) {
    if (!this.isglobalfilter) {
      this.spinner.show();
    }
    filterdata.orgId = this.selectedOrgId;
    this.esignservice.getESignData(filterdata).subscribe((data) => {
      this.tableData = data;
      this.tableData = this.tableData;
      this.totalRecords = this.tableData.length;
      if (data && Object.keys(data).length > 0) {
        this.tableData = data.griddata;
        this.idArray = [];
        this.totalRecords = data.totalcount;
        this.options = this.utilityservice.getOptionDropdown(this.totalRecords);
        this.paginatorArray = this.options.map(e => e.value)
        // if (filterdata.sortField) {
        //   this.utilityservice.sortData(filterdata.sortField, filterdata.sortOrder, this.tableData);
        // }
        if (filterdata.filters) {
          this.tableData = this.utilityservice.columnFilter(filterdata, this.tableData);
        }
      } else {
        this.tableData = [];
        this.totalRecords = 0;
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
      
    });
    
  }
  filterdata: {};

  event: boolean = false;
  isglobalfilter = false;
  filtersObservable = new BehaviorSubject<any>({
    page: 1,
    size: 10,
    sortField: 'createdon',
    sortOrder: 1,
    filters: null,
    orgId: ''
  });
  
  callData(event?: LazyLoadEvent) { 
    this.filtersObservable.subscribe(res => {
      if (event) {
         
        this.first2 = event.first;

        let page = event.first / event.rows + 1;

        res.page = page
        res.size = event.rows;
        this.event = true;
        res['filters'] = event.filters;
        res['sortField'] = event.sortField
        res['sortOrder'] = event.sortOrder;
        if (event.globalFilter !== null) {
          this.isglobalfilter = true
        } else {
          this.isglobalfilter = false
        }
      }
      else {
        res.page = 1;
        res.size = 10;
        res['sortField'] = 'createdon';
        res['sortOrder'] = 1;
        res['filters'] = null;
        this.event = false;
      } this.filterdata = {
        ...res
      };
       
      this.getesigndata(this.filterdata);
    });
  }

  show(title, data) {
    let details = {}
    this.esignservice.getESignById(data.rid).subscribe(res => {
      details = res;
      this.ref = this.dialogService.open(EsignhomemodalComponent, {
        header: title,
        height: '100%',
        width: '90vw',
        data: { title: title, datas: details },
        contentStyle: {},
        baseZIndex: 10000,
        maximizable: true,
      });
      this.ref.onClose.subscribe(() => {
      });
    })
  }
 
  //Download  Excel
  exceDownloadModel( dataRequest) { 
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: '44vw',
      height: '10vw',
      data: {
        excelname: "ESignatures.xlsx", downloadapi: 'common/esign/esigndataexcel',
        method: 'post', message: this.excel_paragraph,
         payload: {
        orgId: this.selectedOrgId,
        dataRequest: dataRequest
      },
      },
      contentStyle: { overflow: 'hidden' },
      position: 'center'

    })
  }

  handlePageChange(event: any) {
    this.rows2 = event.rows
  }
  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;

      // Handling null values
      if (value1 == null && value2 != null) return -1;
      if (value1 != null && value2 == null) return 1;
      if (value1 == null && value2 == null) return 0;

      // Check if the field is createdon for date comparison
      if (event.field === 'createdon') {
        // Parse the date strings to Date objects
        const date1 = new Date(value1);
        const date2 = new Date(value2);
        return date1.getTime() - date2.getTime(); // Sort by timestamp
      }

      // Handle string comparisons
      if (typeof value1 === 'string' && typeof value2 === 'string') {
        return value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
      }

      // Fallback to default number comparison for other types
      return (value1 < value2 ? -1 : (value1 > value2 ? 1 : 0));
    });

    return event.order === -1 ? event.data.reverse() : event.data; // Reverse if descending
  }

  showTableColumns() {
    this.isActivefilter = !this.isActivefilter;
  }

  searchTerm: string = '';
  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }

  onOrgChange(orgId: string) {
    this.selectedOrgId = orgId ?? "0";
    this.getesigndata(this.filterdata);
  }
  
  getOrganisation() {
    this.esignservice.getOrganisation().subscribe(res => {
      this.organisationList = res;
      this.organisationList.unshift({ orgid: '', name: 'Select Organisation' });
    });
  }

}
